module.exports = __webpack_public_path__ + "img/qatar.65963cfc.jpg";